import { FilterFunction } from '../interfaces/FilterFunction';

export function createStringFilterFunction<T>(predicate: (item: T) => unknown): FilterFunction<T, string> {
  return (item: T, filterValue: string) => {
    const value = predicate(item);

    return typeof value === 'string' ? value.toLowerCase().includes(filterValue) : false;
  };
}
